// apps/web/src/features/crm/leads/card/LeadCardSidebar.tsx
//
// Sidebar of the card (#2247 FR-2, re-skinned #2316): a thin host for the
// single "Artifacts" `SectionCard` — linked requests/deals/intake plus
// lead files. `ArtifactsBlock` owns every sub-resource query and the
// manager-only upload/delete gating; this host just wires `leadId`/
// `canManage`/the #2318 CP-create gate through.
import { ArtifactsBlock } from './ArtifactsBlock.js';

export interface LeadCardSidebarProps {
  leadId: string;
  canManage: boolean;
  /** D-1 (#2318): owner-only CP-create gate, computed by the page. */
  canCreateProposal: boolean;
  /** D-2 (#2318): convenience client-name seed for the CP create form. */
  clientPrefill: string;
}

export function LeadCardSidebar({
  leadId,
  canManage,
  canCreateProposal,
  clientPrefill,
}: LeadCardSidebarProps) {
  return (
    <aside style={{ display: 'flex', flexDirection: 'column', gap: 20, minHeight: 0 }}>
      <ArtifactsBlock
        leadId={leadId}
        canManage={canManage}
        canCreateProposal={canCreateProposal}
        clientPrefill={clientPrefill}
      />
    </aside>
  );
}
